import { FC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

interface ConfirmUnsavedChangesDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  t: (key: string) => string;
  confirmButtonLabel?: string;
}

export const ConfirmUnsavedChangesDialog: FC<
  ConfirmUnsavedChangesDialogProps
> = ({
  open,
  onClose,
  onConfirm,
  t,
  confirmButtonLabel = "Common_options.Close",
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("Common_options.Confirm")}</DialogTitle>
      <DialogContent>
        {t("Common_options.Unsaved_changes_will_be_lost")}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("Common_options.Cancel")}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t(confirmButtonLabel)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
